import * as React from 'react';
import toast from 'cogo-toast';
import { Page, Grid, Button, Card, Form } from 'tabler-react';

import Request from '../../shared/request';
import PageComponent from '../PageComponent';

class WechatBind extends PageComponent {
  state = {
    code: null,
  };

  async componentDidMount() {
    const data = await Request.post('checkWechatBind');
    this.setState(data);
  }

  handleCopy = (event, key) => {
    document.querySelector(`[name="copy-${key}"]`).select();
    const success = document.execCommand('copy');
    if (success) {
      toast.info('复制成功');
    } else {
      toast.warn('复制失败 请尝试手动复制');
    }
  };

  async handeReBind() {
    const data = await Request.post('checkWechatBind', { rebind: true });
    this.setState(data);
  }

  render() {
    const { code, userId } = this.state;
    return (
      <Grid.Row className="miao-setting">
        <Grid.Col xl={6} offsetXl={3} lg={6} offsetLg={3}>
          <Page.Card title="绑定微信">
            {!userId ? (
              <Card>
                <Form.Group label="微信绑定码">
                  <Form.InputGroup>
                    <Form.Input name="copy-wechat" readOnly value={code} />
                    <Form.InputGroupAppend>
                      <Button
                        color="primary"
                        onClick={event => this.handleCopy(event, 'wechat')}>
                        复制
                      </Button>
                    </Form.InputGroupAppend>
                  </Form.InputGroup>
                </Form.Group>
                <div>
                  搜索并关注微信公众号【Malus加速器】，发送上述代码即可完成绑定
                </div>
              </Card>
            ) : (
                <Card>已经绑定<Button color="danger" onClick={event => this.handeReBind(event)}>重新绑定</Button></Card>
              )}
          </Page.Card>
        </Grid.Col>
      </Grid.Row>
    );
  }
}

export default WechatBind;
